// Catálogo espejo del backend (src/config/tenantConfigCatalog.ts). El contrato
// entre backend y frontend son las CLAVES. Los defaults reproducen el
// comportamiento actual: un tenant sin config se comporta como siempre.
export const MANTENCION_SETTINGS = [
  {
    key: 'hallazgo_severidad',
    label: 'Pedir criticidad',
    efecto: 'El técnico elige la criticidad (baja a crítica) en cada problema.',
    aviso: 'Al apagarlo, no se registra criticidad en los problemas.',
    default: true,
  },
  {
    key: 'severidad_obligatoria',
    label: 'Criticidad obligatoria',
    efecto: 'No se puede cerrar la mantención si un problema quedó sin criticidad.',
    aviso: 'Al apagarlo, se puede cerrar aunque falte la criticidad.',
    default: true,
    dependsOn: 'hallazgo_severidad',
  },
  {
    key: 'hallazgo_sugerencias',
    label: 'Recomendaciones',
    efecto: 'Además de problemas, el técnico puede registrar recomendaciones.',
    aviso: 'Al apagarlo, solo se registran problemas.',
    default: true,
  },
  {
    key: 'hallazgo_fotos',
    label: 'Fotos en hallazgos',
    efecto: 'El técnico puede adjuntar fotos a cada hallazgo.',
    aviso: 'Al apagarlo, se oculta la cámara y la galería en los hallazgos.',
    default: true,
  },
  {
    key: 'ai_redaccion',
    label: 'Asistente de redacción',
    efecto: 'Antes de firmar, un asistente sugiere mejoras de redacción.',
    aviso: 'Al apagarlo, los textos van tal cual el técnico los escribió.',
    default: true,
  },
];

export const MANTENCION_DEFAULTS = Object.fromEntries(
  MANTENCION_SETTINGS.map((s) => [s.key, s.default])
);
